// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"a54a7ec6","253":"7b3b9eb1","293":"6d112591","450":"b9b096a6","613":"026d5de6","761":"e8833f7a","787":"a90aa9be","961":"914c32f9","964":"7ec3e301","978":"145a7021"}[chunkId] + ".chunk.js";
};